import { render, staticRenderFns } from "./EditableQuestionList.vue?vue&type=template&id=8a64ea6e&scoped=true&"
import script from "./EditableQuestionList.vue?vue&type=script&lang=js&"
export * from "./EditableQuestionList.vue?vue&type=script&lang=js&"
import style0 from "./EditableQuestionList.vue?vue&type=style&index=0&id=8a64ea6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a64ea6e",
  null
  
)

export default component.exports